import React from "react";

interface Props {
  totalQuestions?: number;
  answeredQuestions?: number;
}

const ProgressBar: React.FC<Props> = ({
  totalQuestions = 0,
  answeredQuestions = 0,
}) => {
  const percentage = totalQuestions
    ? Math.round((answeredQuestions / totalQuestions) * 100)
    : 0;
  const percentageText = `${percentage}%`;

  return (
    <div className="progress-bar">
      <span className="percentage-number">{percentageText}</span>
      <span className="progress-wrapper">
        <span
          className="completion-stat"
          style={{ width: percentageText }}
          // style={{ width: "100%" }}
        ></span>
      </span>
      <span className="percentage" style={{ minWidth: "fit-content" }}>
        Instant Routine!
      </span>
    </div>
  );
};

export default ProgressBar;
